export default "__VITE_ASSET__vYIx4tK5__"